import './PosterCard.css'
const PosterCard = () => {
    return ( 
        <div className="mainPosterContainer"></div>
     );
}
 
export default PosterCard;